import * as React from 'react'
import Modal from './components/Modal'
import { BodyMonoText, Spacer } from './components/core'
import { getWindow } from './global'

/**
 * The browser only allows clipboard write from inside a user triggered event--a click or keystroke.
 *
 * If you need to write to clipboard from anywhere else, use this modal.
 */
export class ClipboardModal extends React.PureComponent<{ title: string; clip: string; onClose: () => void }> {
  render() {
    const { title, clip, onClose } = this.props
    return (
      <Modal title={title} width={720} onClose={onClose}>
        <Spacer height={16} />
        <BodyMonoText color="silver" ref={this.textRef}>
          {clip}
        </BodyMonoText>
      </Modal>
    )
  }

  private textRef = (text: HTMLDivElement) => {
    if (text != null) {
      getWindow()!.getSelection()!.selectAllChildren(text)
    }
  }
}

/**
 * Doesn't work reliably, even with fallback and even during user-triggered events :(
 */
export function copyToClipboard(text: string) {
  console.log('Copy to clipboard ' + text.length + ' chars')
  navigator.clipboard.writeText(text).catch(() => fallbackCopy(text))
}

function fallbackCopy(text: string) {
  console.log('Fallback copy to clipboard ' + text.length + ' chars')
  const el = document.createElement('textarea')
  el.value = text
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}
